import { BalanceThreshold } from "../Balance.types";
import { formatDecimalWithMinNumberOfDecimals, removeTrailingZeros } from "./balance.utils";

export const getDecimalsFromThreshold = (balance: string, thresholds: BalanceThreshold[]): number | undefined => {
    const [intBalance, tempDecBalance] = balance.split(".");
    if (intBalance === undefined) return;

    const intBalanceAsBigInt = BigInt(intBalance);
    const decBalance = removeTrailingZeros(tempDecBalance || "0");

    const threshold = thresholds.find((threshold) => {
        const [intThreshold, tempDecThreshold] = threshold.value.toString().split(".");
        const intThresholdAsBigInt = BigInt(intThreshold);
        const decThreshold = removeTrailingZeros(tempDecThreshold || "0");

        return (
            intBalanceAsBigInt > intThresholdAsBigInt ||
            (intBalanceAsBigInt === intThresholdAsBigInt &&
                BigInt(formatDecimalWithMinNumberOfDecimals(decBalance, Math.max(decBalance.length, decThreshold.length))) >=
                    BigInt(formatDecimalWithMinNumberOfDecimals(decThreshold, Math.max(decBalance.length, decThreshold.length))))
        );
    });

    return threshold?.decimals === undefined ? -1 : threshold.decimals; // skipcq: JS-0045
};
